module.exports = __webpack_public_path__ + "static/img/bg-second-floor.6e55c6e5.png";